<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <tt-input ttLabel="search_resource_name" [ttModel]="page.search_resource_name" ttReadonly></tt-input>
        <tt-input ttLabel="searchtext" [(ttModel)]="page.searchtext" ttShowClearButton></tt-input>
        <tt-list [ttData]="crews" [ttFilter]="page.searchtext"></tt-list>
        <tt-button ttText="srcrews_new" ttIcon="fas fa-plus" ttIconPullRight ttTextAlign="left" ttGoto="srcrew" [ttGotoParms]="{ resource_id: page.search_resource_id, srcrew_keyno: '0' }"></tt-button>
    </tt-card>
</tt-page>
